import React from "react";
import EditableInput from "./EditableInput";
import { buildCompactPreview } from "../../../utils/editableRecord";

const LargeArrayEditor = ({
  entry,
  arrayItems,
  selectedIndex,
  onSelectIndex,
  onAddItem,
  onRemoveItem,
  selectedItem,
  onChangeItem,
}) => (
  <div className="space-y-3 rounded-2xl border border-slate-800/90 bg-slate-950/40 p-4">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div className="min-w-[12rem] flex-1 relative">
        <p className="text-xs text-slate-400">Edit one item at a time.</p>
        <select
          value={selectedIndex >= 0 ? String(selectedIndex) : ""}
          onChange={(event) => onSelectIndex(Number(event.target.value))}
          disabled={!arrayItems.length}
          aria-label={`${entry.label} selected item`}
          className="mt-2 min-h-[3rem] w-full appearance-none rounded-2xl border border-slate-700 bg-slate-950/80 px-4 py-3 pr-10 text-sm text-slate-100 outline-none transition-all focus:border-sky-500/60 focus:ring-2 focus:ring-sky-500/20 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {arrayItems.map((item, index) => (
            <option key={`${entry.key}-option-${index}`} value={index}>
              {`Item ${index + 1} - ${buildCompactPreview(item?.textValue ?? item?.templateValue)}`}
            </option>
          ))}
        </select>
         <span className="pointer-events-none absolute right-4 top-1/2 pt-3 translate-y-[-35%] text-slate-400">▼</span>
      </div>

      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={onAddItem}
          className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-slate-500 hover:text-white"
          aria-label={`Add ${entry.label} item`}
        >
          Add item
        </button>
        <button
          type="button"
          onClick={() => onRemoveItem(selectedIndex)}
          disabled={selectedIndex < 0}
          className="rounded-lg border border-rose-500/30 bg-rose-500/10 px-3 py-2 text-xs font-semibold text-rose-100 transition-colors hover:border-rose-400 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
          aria-label={`Remove ${entry.label} item`}
        >
          Remove item
        </button>
      </div>
    </div>

    {selectedItem ? (
      <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-3">
        <div className="mb-2 flex items-center justify-between gap-3">
          <span className="text-xs font-medium uppercase tracking-[0.12em] text-slate-500">
            Item {selectedIndex + 1}
          </span>
          <span className="text-xs text-slate-400">
            {selectedItem.mode === "json" ? "JSON value" : "Text value"}
          </span>
        </div>
        <EditableInput
          value={selectedItem.textValue ?? ""}
          onChange={(event) => onChangeItem(selectedIndex, event.target.value)}
          multiline
          rows={selectedItem.mode === "json" ? 8 : 6}
          ariaLabel={`${entry.label} item ${selectedIndex + 1}`}
          placeholder={selectedItem.mode === "json" ? "Enter valid JSON for this item" : ""}
        />
      </div>
    ) : (
      <div className="rounded-2xl border border-dashed border-slate-700 px-4 py-4 text-sm text-slate-400">
        No items yet. Add one to start editing this field.
      </div>
    )}
  </div>
);

export default LargeArrayEditor;
